import * as API from '@siloreal:shared:api';

const SILOBAG_PERMISSION_LIST_ENDPOINT = '/silobags_permissions';

export type SilobagPermissionListServiceContract = {
  query: SilobagPermissionListQuery;
  signal?: AbortSignal;
};

export async function listSilobagPermissionsService(
  contract: SilobagPermissionListServiceContract
): Promise<SilobagPermissionListResponse> {
  const { data } = await API.http.fetch.get<SilobagPermissionListResponse>(SILOBAG_PERMISSION_LIST_ENDPOINT, {
    query: buildSilobagPermissionListQuery(contract.query),
    signal: contract.signal,
  });

  return data;
}

export type SilobagPermissionListQuery = SilobagPermissionListSilobagId | SilobagPermissionListSilobagId[];

export type SilobagPermissionListSilobagId = string | number;

export type SilobagPermissionListResponse = {
  error: boolean;
  response: SilobagPermissionListItem[];
};

export type SilobagPermissionListItem = {
  id: number;
  active: boolean;
  created_at: Date | string;
  updated_at: Date | string | null;
  permission_id: number;
  silobag_id: string;
  user_id: number;
  read_permission: boolean;
  write_permission: boolean;
  full_permission: boolean;
  inherited: boolean;
  is_guest: boolean;
  users: SilobagPermissionListUser;
};

export type SilobagPermissionListUser = {
  id: number;
  email: string;
};

function buildSilobagPermissionListQuery(query: SilobagPermissionListQuery): string {
  const silobagIds = (Array.isArray(query) ? query : [query]).filter(
    (silobagId) => `${silobagId}`.length > 0
  );

  if (silobagIds.length === 0) return '';

  return `/${silobagIds.map((silobagId) => encodeURIComponent(silobagId)).join(',')}`;
}
